<template>
	<el-main class="info-wrap">
		<div class="info-box" v-loading="loading">
			<div v-if="info.id > 0" class="info-item">
				<div class="info-head tc">
					<h3>{{ info.title }}</h3>
				</div>

				<div class="list-box" style="padding: 0 140px 20px" :loading="submitting" loading-text="提交中...">
					<el-form ref="form" :model="form" label-width="100px" :rules="rules" label-position="top">
						<el-row :gutter="40" v-if="form.feebackStandards">
							<el-col :span="24">
								<el-form-item label="涉及标准：" prop="feebackStandards">
									<el-input type="text" v-model="form.feebackStandards" placeholder="请输入法规标准信息" readonly></el-input>
								</el-form-item>
							</el-col>
						</el-row>

						<el-row :gutter="40">
							<el-col :span="24">
								<el-form-item label="问题类型：" prop="feebackType">
									<el-radio-group v-model="form.feebackType">
										<el-radio v-for="item in typeList" :key="item.id" :label="item.id">{{ item.typeName }}</el-radio>
									</el-radio-group>
									<!-- <el-select v-model="form.feebackType" placeholder="请选择问题类型" style="width: 100%">
										<el-option v-for="item in typeList" :key="item.id" :label="item.typeName" :value="item.id"></el-option>
									</el-select> -->
								</el-form-item>
							</el-col>
						</el-row>

						<el-row :gutter="40">
							<el-col :span="24">
								<el-form-item label="问题说明：" prop="feebackInfo">
									<div slot="label">
										<span><i class="required"></i>问题说明：</span>
									</div>
									<RichEditor v-model="form.feebackInfo" placeholder="请详细描述您遇到的问题（支持粘贴图片）" @change="handleFeebackInfoChange"></RichEditor>
								</el-form-item>
							</el-col>
						</el-row>

						<el-row :gutter="40">
							<el-col :span="12">
								<el-form-item label="手机号码：" prop="contactPhone">
									<el-input v-model="form.contactPhone" placeholder="请输入您的手机号码以便我们及时联系您"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="姓名：" prop="contactPerson">
									<el-input v-model="form.contactPerson" placeholder="请输入您的姓名（非必填）"></el-input>
								</el-form-item>
							</el-col>
						</el-row>

						<el-row :gutter="40">
							<el-col :span="12">
								<el-form-item label="补充资料：" prop="files">
									<UploadFileSingle
										ref="UploadFileSingleRef"
										v-model="fileList"
										:fileType="['pdf', 'png', 'jpg', 'jpeg', 'gif', 'doc', 'docx']"
										:limit="1"
										:file-size="10"
										@change="handleFileChange"
									></UploadFileSingle>
								</el-form-item>
							</el-col>
						</el-row>

						<el-row :gutter="40">
							<el-col :span="24">
								<div style="text-align: center; margin-top: 20px">
									<el-button type="primary" @click="onSubmit" :loading="submitting">立即提交</el-button>
									<el-button @click="resetForm">重置</el-button>
								</div>
							</el-col>
						</el-row>
					</el-form>
				</div>
			</div>

			<el-card v-else class="no-data-box" shadow="nerver">
				<el-empty description="暂无数据"></el-empty>
			</el-card>
		</div>
	</el-main>
</template>

<script>
	import UploadFileSingle from '@/components/UploadFileSingle/index.vue';
	import RichEditor from '@/components/Tools/WEditor.vue';
	import { postMemberFeedback, getMemberFeedbackTypeList } from '@/api/user/feekback.js';

	export default {
		data() {
			return {
				loading: false,
				autosizeObj: { minRows: 5, maxRows: 10 },
				editorReady: false, // 编辑器初始化完成标记
				form: {
					feebackStandards: '',
					feebackTitle: '',
					feebackType: '',
					feebackInfo: '',
					contactPerson: '',
					contactPhone: '',
					feebackAnnex: '' // 文件列表字符串
				},
				fileList: '', // 文件列表，用于UploadFileSingle组件
				isFileRequired: false, // 是否必填文件上传
				standardContext: { feebackStandards: '', feebackTitle: '' }, // 保存标准上下文，重置时恢复
				info: {
					id: 999,
					title: '在线问题反馈',
					content: '请您留下宝贵意见'
				},
				rules: {
					feebackType: [{ required: true, message: '请选择问题类型', trigger: 'change' }],
					feebackInfo: [
						{ validator: this.validateFeebackInfo }
					],
					contactPhone: [
						{ required: true, message: '请输入手机号码', trigger: 'blur' },
						{ pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
					],
					contactPerson: [{ min: 2, max: 10, message: '姓名长度在 2 到 10 个字符', trigger: 'blur' }],
					files: [{ validator: this.validateFiles, trigger: 'change' }] // 文件上传校验，目前为可选
				},
				typeList: [],
				submitting: false
			};
		},
		components: {
			UploadFileSingle,
			RichEditor
		},
		methods: {
			getMemberFeedbackTypeList() {
				getMemberFeedbackTypeList().then(res => {
					if (res.code == 200) {
						this.typeList = res.data;
					}
				});
			},

			onSubmit() {
				this.$refs.form.validate(valid => {
					if (valid) {
						this.submitting = true;
						postMemberFeedback(this.form).then(res => {
							if (res.code === 200) {
								this.$message.success('问题已成功提交！');
								// 重置表单
								this.resetForm();
							} else {
								this.$message.error(res.msg || '问题提交失败');
							}
							this.submitting = false;
						});
					}
				});
			},

			handleFileChange(fileList) {
				const prefix = '/third/files/info/';
				const key = fileList.replace(prefix, '');
				this.form.feebackAnnex = key;
				// 手动触发表单验证
				if (this.$refs.form) {
					this.$refs.form.validateField('files');
				}
			},

			// 自定义文件验证器
			validateFiles(rule, value, callback) {
				if (this.isFileRequired) {
					// 如果设置为必填
					if (!value || value.trim() === '') {
						callback(new Error('请上传补充资料'));
					} else {
						callback();
					}
				} else {
					// 文件上传是可选的，直接通过
					callback();
				}
			},

			// 富文本问题说明验证：去除空标签后校验实际内容（纯图片也算有内容）
			validateFeebackInfo(rule, value, callback) {
				const html = value || '';
				// 检查是否有图片
				const hasImage = /<img\b/i.test(html);
				// 去除HTML标签，只保留纯文本
				const text = html.replace(/<[^>]+>/g, '').replace(/&nbsp;/g, ' ').trim();
				if (!text && !hasImage) {
					callback(new Error('请描述您遇到的问题'));
				} else if (text.length < 1 && !hasImage) {
					callback(new Error('问题说明不能为空'));
				} else if (text.length > 500) {
					callback(new Error('问题说明长度不能超过 500 个字符'));
				} else {
					callback();
				}
			},

			handleFeebackInfoChange() {
				// 跳过初始化时的首次 change 事件，避免误触发校验
				if (!this.editorReady) {
					this.$nextTick(() => {
						this.editorReady = true;
					});
					return;
				}
				// 内容变化时手动触发校验，清除错误提示
				if (this.$refs.form) {
					this.$refs.form.validateField('feebackInfo');
				}
			},

			resetForm() {
				this.submitting = false;
				this.editorReady = false; // 重置编辑器标记，避免重置时触发校验
				this.$refs.form.resetFields();
				this.form.feebackAnnex = ''; // 清空文件列表字符串
				this.$refs.UploadFileSingleRef.clearFileList();
				// 恢复标准上下文（resetFields 会将其重置为空）
				this.form.feebackStandards = this.standardContext.feebackStandards;
				this.form.feebackTitle = this.standardContext.feebackTitle;
			},

			// 移除 URL 中的标准信息参数
			clearStandardQueryParams() {
				const query = { ...this.$route.query };
				delete query.standardId;
				delete query.standardName;
				delete query.standardCode;
				delete query.pageType;
				this.form.feebackStandards = '';
				this.form.feebackTitle = '';
				this.$router.replace({ path: this.$route.path, query });
			}
		},

		// 加载完执行
		created() {
			this.getMemberFeedbackTypeList();
			// 从法规标准页面跳转时携带标准信息，设置反馈标题
			const { standardId, standardName, standardCode, pageType } = this.$route.query;
			if (standardId) {
				// 详情括号：标准相关信息
				let detailParts = [`id：${standardId}`];
				if (standardName) detailParts.push(`标准名称：${standardName}`);
				if (standardCode) detailParts.push(`标准编号：${standardCode}`);
				let title = pageType ? `未登录-${pageType}（${detailParts.join('-')}）` : `未登录（${detailParts.join('-')}）`;
				this.form.feebackTitle = title;
				let std = standardCode ? standardCode + ' ' + standardName : standardName;
				if (pageType && pageType !== '详情') std += `（${pageType}）`;
				this.form.feebackStandards = std;
				this.standardContext = { feebackStandards: std, feebackTitle: title };
			} else {
				this.form.feebackStandards = '';
				this.form.feebackTitle = '';
				this.standardContext = { feebackStandards: '', feebackTitle: '' };
			}
		},
	};
</script>

<style lang="less" scoped>
	.info-wrap {
		// margin-left: 20px;
		padding: 20px 0;
		font-size: 14px;
		color: #686f83;
		line-height: 1.8;
		background-color: #ffffff;
		box-shadow: 0px 3px 7px 0px rgba(0, 122, 255, 0.1);
		border-radius: 15px;
		min-height: calc(100vh - 120px);

		/deep/ .el-form-item__label {
			font-size: 16px;
			color: #262626;
			font-weight: 600;
		}
		h3 {
			margin: 0 0 10px;
			font-size: 24px;
			color: #262626;
			font-weight: 700;
		}
	}
	.info-item {
		margin-bottom: 20px;
	}
	.info-head {
		margin-bottom: 25px;
		padding-bottom: 28px;
		border-bottom: 1px solid #cccccc;
		margin-top: 20px;
		.topbox {
			color: #888888;
			dd {
				margin: 0 30px 0 0;
			}
		}
	}
	.info-content {
		text-indent: 2em;
	}
	.required::before {
		content: "*";
		color: #ef4444;
		font-style: normal;
		margin-right: 4px;
	}
</style>
